/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path, Line, Polyline } from 'react-native-svg';

import { IconProps } from '../lib';

function PersonSimpleWalk(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle cx={152} cy={48} r={24} opacity={0.2} />
      <Circle
        cx={152}
        cy={48}
        r={24}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M48,128s56-56,88-26.449C153.94081,118.11882,168,144,208,144"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={130.51056}
        y1={97.4257}
        x2={72}
        y2={232}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Polyline
        points="152 232 152 176 109.536 145.668"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default PersonSimpleWalk;
